import clsx from "clsx";

// MUI
import { Stack } from "@mui/material";
import type { GridOverlayProps } from "@mui/x-data-grid-premium";
import type { SxProps, Theme } from "@mui/material/styles";

interface NoRowsOverlayProps extends GridOverlayProps {
	title?: string;
}

export default function NoRowsOverlay(props: Readonly<NoRowsOverlayProps>) {
	return (
		<Stack
			className={clsx({
				"!font-montserrat text-[16px] text-[color:--text-color]": true,
				"w-full h-full justify-center text-center": true,
				[props?.className ?? ""]: true,
			})}
			sx={props?.sx as SxProps<Theme>}
		>
			{props?.title ?? "No rows"}
		</Stack>
	);
}
